import { DatePicker } from "antd";
import axios from "axios";
import {
  Button,
  Table,
  TableCard,
  Export,
} from "components";
import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import { IoSearchOutline } from "react-icons/io5";

function ProfitReport() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [dateRange, setDateRange] = useState([dayjs(), dayjs()]);
  const [currentPage, setCurrentPage] = useState(0);
  const [warehouseid, setWarehouseid] = useState(null);
  const [warehouses, setWarehouses] = useState([]);

  const handleSearch = () => {
    if (!dateRange || dateRange.length !== 2) return;
    setLoading(true);

    const startDate = dateRange[0].format('YYYY-MM-DD');
    const endDate = dateRange[1].format('YYYY-MM-DD');

    const url = warehouseid 
      ? `/report/profit/${startDate}/${endDate}?warehouseid=${warehouseid}`
      : `/report/profit/${startDate}/${endDate}`;

    axios.get(url)
      .then((res) => setData(res.data))
      .catch((err) => console.error("Error fetching profit report:", err))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    handleSearch();
    getWarehouse();
  }, []);

  const getWarehouse = () => {
    axios.get("/warehouses")
      .then((res) => {
        if (Array.isArray(res.data)) {
          setWarehouses(res.data.map(w => ({ id: w.id, name: w.name })));
        }
      })
      .catch((err) => console.error('Error fetching warehouses:', err));
  };

  const columns = [
    { title: "№", dataIndex: "No", key: "No", width: 50, align: "center", fixed: true, cellRender: (e) => <span>{e.rowIndex + currentPage + 1}</span> },
    { title: "Зураг", dataIndex: "image", key: "image", fixed: true, cellRender: ({ value }) => (<img src={`${process.env.REACT_APP_CDN_URL}${value}`} alt="" className="w-[30px] h-[30px] object-cover" />) },
    { title: "Агуулах", dataIndex: "warehouse_name", key: "warehouse_name", fixed: true },
    { title: "Бараа", dataIndex: "product_name", key: "product_name", fixed: true },
    { title: "Хэмжээ", dataIndex: "size", key: "size", fixed: true },
    { title: "Өнгө", dataIndex: "color", key: "color", fixed:true },
    { title: "Үлдэгдэл", dataIndex: "balance", key: "balance", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ш` : "-") },
    { title: "Дундаж Өртөг", dataIndex: "average_cost", key: "average_cost", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ₮` : "-") },
    { title: "Үлдэгдэл Нийт Өртөг", dataIndex: "total_inventory_cost", key: "total_inventory_cost", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ₮` : "-") },
    { title: "Нийт зарсан", dataIndex: "total_sold_qty", key: "total_sold_qty", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ш` : "-") },
    { title: "Борлуулсан үнэ", dataIndex: "sales_amount", key: "sales_amount", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ₮` : "-") },
    { title: "Борлуулалт", dataIndex: "total_sales_amount", key: "total_sales_amount", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ₮` : "-") },
    { title: "Нийт ашиг", dataIndex: "total_profit", key: "total_profit", cellRender: ({ value }) => (value ? `${value.toLocaleString()} ₮` : "-") },
  ];

  const totalSales = data.reduce((sum, item) => sum + (item.total_sales_amount || 0), 0);
  const totalProfit = data.reduce((sum, item) => sum + (item.total_profit || 0), 0);
  const totalSoldQty = data.reduce((sum, item) => sum + (item.total_sold_qty || 0), 0);

  return (
    <div className="p-2">
      <TableCard
        header={
          <div className="flex flex-wrap items-center justify-between gap-2">
            <h1 className="text-xl font-semibold">Ашиг орлогийн тайлан</h1>
            <div className="flex flex-wrap items-center gap-2 text-sm">
              <select 
                value={warehouseid || ""}
                onChange={(e) => setWarehouseid(e.target.value)}
                className="border border-gray-300 rounded-md h-8 text-sm px-2"
              >
                <option value="">Бүх агуулах</option>
                {warehouses.map((wh) => (
                  <option key={wh.id} value={wh.id}>{wh.name}</option>
                ))}
              </select>
              <DatePicker.RangePicker
                value={dateRange}
                onChange={(values) => setDateRange(values)}
                format="YYYY-MM-DD"
                size="small"
                style={{ height: 32 }}
              />
              <Button
                type="primary"
                icon={<IoSearchOutline />}
                onClick={handleSearch}
                loading={loading}
                // size="small"
              >
                Хайх
              </Button>
              <Export fileData={data} fileName={"Ашиг орлогийн тайлан"} />
            </div>
          </div>
        }
      >
        <Table 
          dataSource={data}
          columns={columns}
          loading={loading}
          columnMinWidth={120}
          scrolling={{ x: "max-content", y: 500 }}
          tableClass="text-xs" // text жижиг
        />
        <div className="flex flex-wrap justify-end mt-2 gap-4 text-sm">
          <div>Нийт зарсан бараа: {totalSoldQty.toLocaleString()} ш</div>
          <div>Нийт борлуулалт: {totalSales.toLocaleString()} ₮</div>
          <div>Нийт ашиг: {totalProfit.toLocaleString()} ₮</div>
        </div>
      </TableCard>
    </div>
  );
}

export default ProfitReport;
